import React, { useEffect } from 'react'
import HomeTop from './HomeTop'
import HomeFooter from './HomeFooter'
import { Button, Grid } from '@mui/material'
// import { useNavigate } from "react-router-dom";

function ResidentFeatures() {
    // const navigate = useNavigate();
     useEffect(() => {
            window.scrollTo(0, 0); // Scroll to top on component mount
          }, []);
  return (
    <>
     <HomeTop />

<div className='adminBannerMain whiteBG'>
    <div className='container'>
        <div className='adminBannerContent'>
           
        <h1>Resident Features</h1>
                <p>The Resident module in software allows for efficient management of resident information, lease agreements, and communication preferences, ensuring smooth interaction between residents and management. It facilitates easy tracking of occupancy status, maintenance dues, and communication logs, streamlining administrative tasks and enhancing resident satisfaction with transparent and organized community management.</p>
            
           </div>
    </div>
</div>

<div className='sectionMain'>
    <div className='innerPagesFeaturesOuter'>
        <div className='container'>
            <div className='innerPagesFeaturesInner'>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <div className='featureOuter'>
                            <h3>Profile Management</h3>
                            <p>Update details such as Name, Email Id, Age, Family Info, Vehicle Info, Tenant Info, Documents.</p>
                         
                        </div>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <div className='featureOuter'>
                            <h3>Service Providers Management</h3>
                            <p>Find and add service providers working in the society premises.</p>
                        </div>
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <div className='featureOuter'>
                            <h3>Invoices</h3>
                            <p>View complete Invoices raised by the management committee.</p>
                        </div>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <div className='featureOuter'>
                            <h3>Notice board</h3>
                            <p>View important society related notices.</p>
                        </div>
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <div className='featureOuter'>
                            <h3>Resident Directory</h3>
                            <p>List of all the Society Residents.</p>
                        </div>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <div className='featureOuter'>
                            <h3>Notifications</h3>
                            <p>Get important notifications related to the society.</p>
                        </div>
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <div className='featureOuter'>
                            <h3>Discussion Forum</h3>
                            <p>Initiate a conversation for discussing society related issues.</p>
                        </div>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <div className='featureOuter'>
                            <h3>Events</h3>
                            <p>Create upcoming society events.</p>
                        </div>
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <div className='featureOuter'>
                            <h3>Complaints</h3>
                            <p>Raise and keep a track of the complaints regarding society issues to the management committee.</p>
                      
                        </div>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <div className='featureOuter'>
                            <h3>Polls</h3>
                            <p>Conduct society polls for getting valuable feedback from other Residents.</p>
                        </div>
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <div className='featureOuter'>
                            <h3>Support Tickets</h3>
                            <p>Raise Support Tickets to the management committee.</p>
                        </div>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <div className='featureOuter'>
                            <h3>Visitor Management</h3>
                            <p>Approve/Reject visitors to the apartment.</p>
                        </div>
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <div className='featureOuter'>
                            <h3>SOS</h3>
                            <p>Raise alerts in case of emergencies.</p>
                        </div>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        
                    </Grid>
                </Grid>
            </div>
        </div>
    </div>

</div>

<div className='contactFormMain'>
    <div className='sectionMain'>
        <div className='container'>
            <div className='contactForm'>
                <h1 className='sectionHeading' style={{ color: '#ffffff' }}>Connect With Us</h1>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={4}>
                        <input
                            className="contactInput"
                            placeholder="Enter name"
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <input
                            className="contactInput"
                            placeholder="Enter mobile number"
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <input
                            className="contactInput"
                            placeholder="Enter email id"
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <input
                            className="contactInput"
                            placeholder="Enter society name"
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <input
                            className="contactInput"
                            placeholder="Select Location"
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <input
                            className="contactInput"
                            placeholder="Enter City"
                        />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <Button className='contactBtn'>Submit</Button>
                    </Grid>
                </Grid>
            </div>
        </div>
    </div>
</div>

<HomeFooter />
    </>
  )
}

export default ResidentFeatures